module.exports = __webpack_public_path__ + "img/4.4fdf6813.gif";